import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { SimilarPosts } from 'components/blog';
import { SimilarPostsFactory } from './SimilarPostsFactory';

const SimilarPostsLegacyContainer = (props) => (
  <StaticQuery
    query={graphql`
      query SimilarPostsLegacy {    
        allMarkdownRemark {
          nodes {
            frontmatter {
              author
              category
              description
              image
              title
            }
            fields {
              date
              slug
            }
          }
        }
      }
    `}
    render={data => {
      const {
        categories,
        currentPostSlug
      } = props;
      const posts = data.allMarkdownRemark.nodes;
      const mappedPosts = posts.map(post => {
        return {
          legacyPost: true,
          date: post.fields.date,
          slug: post.fields.slug,
          author: post.frontmatter.author,
          category: post.frontmatter.category,
          image: post.frontmatter.image,
          title: post.frontmatter.title
        };
      });

      // Use a SimilarPostsFactory to get similar posts for all other posts
      const similarPosts = new SimilarPostsFactory(
        mappedPosts, currentPostSlug
      )
        .setMaxPosts(2)
        .setCategory([])
        .setTags(categories)
        .getPosts();

      // Render it
      return (
        <SimilarPosts
          posts={similarPosts}
        />
      );
    }}
  />
);

export default SimilarPostsLegacyContainer;

SimilarPostsLegacyContainer.propTypes = {
  categories: PropTypes.array,
  currentPostSlug: PropTypes.string.isRequired
};
